import {
  DocumentActionCategoryType,
  DocumentActionType,
  FileDocumentResponse,
} from '@finxone-platform/shared/sys-config-types';
import { Observable, of } from 'rxjs';

export class MockDocumentService {
  constructor() {}

  public uploadDocument(payload: FormData): Observable<FileDocumentResponse[]> {
    return of([
      {
        entityId: 'c89d3555-150d-4fd6-9d6a-6962481d685c',
        fileId: 'f6fbe697-9f0b-4867-b134-b4a1fb4424cc',
        type: 'transaction-receipt',
        id: 'af1e3a01-b88b-4830-bafd-459a3c3327bd',
        createdAt: new Date('2025-06-18T07:31:43.002Z'),
        updatedAt: new Date('2025-06-18T07:31:43.002Z'),
        name: 'transaction-receipt',
      },
    ]);
  }

  public getDocumentFileId(
    type: DocumentActionType,
    transactionId: string,
  ): Observable<FileDocumentResponse[]> {
    return of([
      {
        entityId: 'c89d3555-150d-4fd6-9d6a-6962481d685c',
        fileId: 'f6fbe697-9f0b-4867-b134-b4a1fb4424cc',
        type: 'transaction-receipt',
        id: 'af1e3a01-b88b-4830-bafd-459a3c3327bd',
        createdAt: new Date('2025-06-18T07:31:43.002Z'),
        updatedAt: new Date('2025-06-18T07:31:43.002Z'),
        name: 'transaction-receipt',
      },
    ]);
  }

  public getDocumentFiles(
    type: DocumentActionType,
    entityId: string,
    category: DocumentActionCategoryType,
  ): Observable<FileDocumentResponse[]> {
    return of([
      {
        entityId: 'c89d3555-150d-4fd6-9d6a-6962481d685c',
        fileId: 'f6fbe697-9f0b-4867-b134-b4a1fb4424cc',
        type: 'transaction-receipt',
        id: 'af1e3a01-b88b-4830-bafd-459a3c3327bd',
        createdAt: new Date('2025-06-18T07:31:43.002Z'),
        updatedAt: new Date('2025-06-18T07:31:43.002Z'),
        name: 'transaction-receipt',
      },
      {
        id: '/2302/13013812/13013812-20210405-TaxCertificate.pdf',
        name: 'Account Statements',
        type: 'saving-accounts',
        category: 'account-statements',
        entityId: '10007403',
        fileId: '/2302/13013812/13013812-20210405-TaxCertificate.pdf',
        createdAt: new Date('2021-04-04T18:30:00.000Z'),
        updatedAt: new Date('2021-04-04T18:30:00.000Z'),
        path: '/2302/13013812/13013812-20210405-TaxCertificate.pdf',
      },
      {
        id: '/2302/13013812/13013812-20220405-TaxCertificate.pdf',
        name: 'Tax Certificate-05-04-2022',
        type: 'saving-accounts',
        category: 'tax-certificates',
        entityId: '10007403',
        fileId: '/2302/13013812/13013812-20220405-TaxCertificate.pdf',
        createdAt: new Date('2022-04-04T18:30:00.000Z'),
        updatedAt: new Date('2022-04-04T18:30:00.000Z'),
        path: '/2302/13013812/13013812-20220405-TaxCertificate.pdf',
      },
      {
        id: '/2302/13013812/SavingTermsAndConditions.pdf',
        name: 'Account Document -05-04-2024',
        type: 'saving-accounts',
        category: 'account-documents',
        entityId: '10007403',
        fileId: '/2302/13013812/SavingTermsAndConditions.pdf',
        createdAt: new Date('2021-03-04T18:30:00.000Z'),
        updatedAt: new Date('2021-03-04T18:30:00.000Z'),
        path: '/2302/13013812/SavingTermsAndConditions.pdf',
      },
    ]);
  }

  public getFile(type: DocumentActionType, entityId: string) {
    return of([
      {
        path: 'assets/images/documents-image/transaction-receipt.png',
      },
    ]);
  }
}
